<template>
    <div class="Table-row">
        <div class="Table-row-item row--xs" data-header="">
            <CustomCheckbox :id="item.id" v-model="checked" />
        </div>
        <div class="Table-row-item" :data-header="header[0].name">{{ item.name }}</div>
        <div class="Table-row-item" :data-header="header[1].name">
            {{ item.objects.length }}
            {{ item.objects.length > 1 ? "groupes d'objets" : "groupe d'objets" }}
        </div>
        <div class="Table-row-item" :data-header="header[2].name">
            <CustomIcon :icon="item.icon" />
        </div>
        <div class="Table-row-item" :data-header="header[3].name">
            <span class="color-pill" :style="{ backgroundColor: item.color }"></span>
        </div>
        <div class="row-actions">
            <font-awesome-icon
                title="Modifier"
                icon="pencil-alt"
                class="row-actions--icon"
                @click="handleEdit(item.id)"
            />
            <font-awesome-icon
                title="Supprimer"
                icon="trash-alt"
                class="row-actions--icon alert"
                @click="handleConfirm(item.id)"
            />
        </div>
    </div>
</template>

<script>
import CustomCheckbox from '@/components/Checkbox';
import CustomIcon from '@/components/Icon';

export default {
    props: {
        header: { type: Array, required: true },
        item: { type: Object, required: true },
        selected: [Array],
        handleEdit: { type: Function },
        handleConfirm: { type: Function },
    },
    data() {
        return {
            checked: this._getCheck(this.selected),
        };
    },
    watch: {
        selected(val) {
            this.checked = this._getCheck(val);
        },
        checked(val) {
            this.$emit('selected', { id: this.item.id, checked: val });
        },
    },
    methods: {
        _getCheck(val) {
            return val && val.some((s) => s === this.item.id);
        },
    },
    components: {
        CustomCheckbox,
        CustomIcon,
    },
};
</script>

<style lang="scss">
.color-pill {
    border-radius: 50%;
    width: 12px;
    height: 12px;
    align-self: center;
}
</style>
